import React from "react";
import { Helmet } from "react-helmet-async";
import Heading from "../components/common/Heading";
import Attractions from "../components/home/Attraction";
import QuickFacts from "../components/common/QuickFacts";

export default function Attraction() {
  return (
    <>
      <Helmet>
        <title>Nearby Attractions & Jodhpur Sightseeing | HariKunj Resort</title>
        <meta
          name="description"
          content="Discover top historical Jodhpur landmarks near HariKunj Resort. Plan trips to Mehrangarh Fort, Umaid Bhawan Palace, Kaylana Lake, and Umaid Sagar Bandh."
        />
        <link rel="canonical" href="https://harikunjresort.com/attractions" />
        <meta property="og:title" content="Nearby Attractions & Jodhpur Sightseeing | HariKunj Resort" />
        <meta property="og:description" content="Discover top historical Jodhpur landmarks near HariKunj Resort. Plan trips to Mehrangarh Fort, Umaid Bhawan Palace, Kaylana Lake, and Umaid Sagar Bandh." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://harikunjresort.com/attractions" />
        <meta property="og:image" content="https://harikunjresort.com/assets/img/Mehrangarh-Fort.webp" />
      </Helmet>

      <Heading heading="Nearby Attractions" title="Home" subtitle="Attractions" />

      <h1 className="visually-hidden">
        Tourist Attractions &amp; Historical Sightseeing Near HariKunj Resort Jodhpur
      </h1>

      <Attractions />
      <QuickFacts pageTitle="Nearby Attractions" />
    </>
  );
}
